export function clamp01(n) {
  if (typeof n !== "number" || Number.isNaN(n)) return null
  return Math.min(1, Math.max(0, n))
}

export function clampNumber(n, min, max) {
  return Math.min(max, Math.max(min, n))
}

